<template>
  <div class="modal_card leave-modal">
    <div class="modal_form">
      <h1>Вы собираетесь покинуть страницу? Возможно, внесенные изменения не сохранятся!</h1>
      <button id="abort-leave-btn" class="close_button modal_button right_button">Отмена</button>
      <button id="confirm-leave-btn" class="add_user_button modal_button left_button">Продолжить</button>
    </div>
  </div>
</template>

<script>
export default {}
</script>
